export default __webpack_public_path__ + "static/media/sign-up-login.16af6871.png";